import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import intl from "../../i18n/intl";

const customIntl = intl();

const initialState = {
  data: [],
  record: null,
  integrations: {},
  requesting: false,
  action: null,
  error: null,
};

const integrationSlice = createSlice({
  name: "integrations",
  initialState,
  reducers: {
    resetError: (state) => {
      state.error = null;
    },
    resetAction: (state) => {
      state.action = null;
    },

    // List integrations
    integrationListRequest: (state) => {
      state.requesting = true;
      state.error = null;
      state.action = "list";
    },
    integrationListSuccess: (state, action) => {
      state.requesting = false;
      state.data = action.payload.response;
    },
    integrationListFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
      state.data = [];
    },

    // Create integration
    integrationCreateRequest: (state) => {
      state.requesting = true;
      state.error = null;
      state.action = "create";
    },
    integrationCreateSuccess: (state, action) => {
      state.requesting = false;
      state.record = action.payload.response;
      toast.success(
        customIntl.formatMessage({ id: "integration_create_success" })
      );
    },
    integrationCreateFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
    },

    // Get integration details
    integrationDetailsRequest: (state) => {
      state.requesting = true;
      state.error = null;
      state.action = "details";
      state.record = null;
    },
    integrationDetailsSuccess: (state, action) => {
      state.requesting = false;
      state.record = action.payload.response;
    },
    integrationDetailsFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
      state.record = null;
    },

    // Update integration
    integrationUpdateRequest: (state) => {
      state.requesting = true;
      state.error = null;
      state.action = "update";
    },
    integrationUpdateSuccess: (state, action) => {
      state.requesting = false;
      state.record = action.payload.response;
      toast.success(
        customIntl.formatMessage(
          { id: "update_success" },
          {
            object: customIntl.formatMessage({ id: "integration" }),
          }
        )
      );
    },
    integrationUpdateFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
    },

    // Delete integration
    integrationDeleteRequest: (state) => {
      state.requesting = true;
      state.error = null;
      state.action = "delete";
    },
    integrationDeleteSuccess: (state, action) => {
      state.requesting = false;
      toast.success(
        customIntl.formatMessage({ id: "integration_delete_success" })
      );
    },
    integrationDeleteFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
    },

    // Get integration subtypes
    integrationSubtypesRequest: (state) => {
      state.requesting = true;
      state.error = null;
      state.action = "subtypes";
    },
    integrationSubtypesSuccess: (state, action) => {
      state.requesting = false;
      const { subtype, data } = action.payload;
      if (!state.integrations) {
        state.integrations = {};
      }
      state.integrations[subtype] = data;
    },
    integrationSubtypesFail: (state, action) => {
      state.requesting = false;
      const { subtype } = action.payload;
      if (state.integrations && subtype && state.integrations[subtype]) {
        delete state.integrations[subtype];
      }
    },
  },
});

export const {
  resetError,
  resetAction,
  integrationListRequest,
  integrationListSuccess,
  integrationListFail,
  integrationCreateRequest,
  integrationCreateSuccess,
  integrationCreateFail,
  integrationDetailsRequest,
  integrationDetailsSuccess,
  integrationDetailsFail,
  integrationUpdateRequest,
  integrationUpdateSuccess,
  integrationUpdateFail,
  integrationDeleteRequest,
  integrationDeleteSuccess,
  integrationDeleteFail,
  integrationSubtypesRequest,
  integrationSubtypesSuccess,
  integrationSubtypesFail,
} = integrationSlice.actions;

export default integrationSlice.reducer;
